import * as React from 'react';
type IconDropDownArrowRoundedProps = React.SVGProps<SVGSVGElement>;

export const IconDropDownArrowRounded: React.FC<IconDropDownArrowRoundedProps> = (props) => (
	<svg
	width={10}
	height={16}
	viewBox="0 0 10 16"
	fill="white"
	xmlns="http://www.w3.org/2000/svg"

	{...props}>
	<g clip-path="url(#clip0_2003_32143)">
	<path d="M4.29378 11.7062C4.68441 12.0968 5.31878 12.0968 5.70941 11.7062L9.70941 7.7062C9.99691 7.4187 10.0813 6.99058 9.92503 6.61558C9.76878 6.24058 9.40628 5.99683 9.00003 5.99683L1.00003 5.99995C0.596906 5.99995 0.231281 6.2437 0.0750307 6.6187C-0.0812193 6.9937 0.00628069 7.42183 0.290656 7.70933L4.29066 11.7093L4.29378 11.7062Z" />
	</g>
	<defs>
	<clipPath id="clip0_2003_32143">
	<rect width="10" height="16" />
	</clipPath>
	</defs>
</svg>

);
export default IconDropDownArrowRounded;
